import React from "react";
import { Segment, Grid } from "semantic-ui-react";
import { Link } from "react-router-dom";
import './WifiSuccess.css';
import {setTitle, setMetaDescription} from '../../util';

const WifiSuccess = (props) => {
  document.title = setTitle(props.title);
  setMetaDescription(props.description);

  return (
    <Segment inverted vertical className="wifi-success">
    <Grid verticalAlign='middle' textAlign='center' className="wifi-success__grid">
      <Grid.Row>
        <Grid.Column>
          <div class="itc-md wifi-success__title">
            Enjoy for 120 minutes.
          </div>
          <div class="itc-md wifi-success__desc">
            Enjoying fast Wi-Fi? Get it for your condo for <span class="text-prime">only $55 monthly.</span>
          </div>
          <div>
            <Link to='/check-availability?utm_source=hotspot&utm_medium=button&utm_campaign=winter' class="ui medium button">Get</Link>
          </div>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </Segment>
  )
};

export default WifiSuccess;



// WEBPACK FOOTER //
// ./src/components/wifi-success/WifiSuccess.js